import { render, staticRenderFns } from "./bulma_empty.vue?vue&type=template&id=0154d729&scoped=true&lang=html"
import script from "./bulma_empty.vue?vue&type=script&lang=js"
export * from "./bulma_empty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0154d729",
  null
  
)

export default component.exports